import React, { useEffect } from 'react';

export function LogoutPage() {
  useEffect(() => {
    localStorage.removeItem('token');
    window.location.href = '/';
  }, []);

  return <div>LogoutPage</div>;
}
